import React from "react";
import Proyecto from "./componentes/Proyecto/Proyecto";

import { BrowserRouter, Route, Routes } from "react-router-dom";

function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Proyecto />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
